import React, { useContext, useEffect, useState } from "react";
import { DataTable } from "../../Common/Controls/Controls";
import "./Demandas.css";

const Demandas = ({ setCurrentRow, setShowModalEdicion, id, datatable }) => {
  return (
    <>
      <div className="AcreditadoDetalleDataTable_header">
        <div className="AcreditadosDetalleTitleTable"></div>
        <div className="AcreditadosDetalleButtons">
          {id !== -1 && (
            <button
              className="btnNuevaGestion"
              onClick={() => {
                setCurrentRow({
                  AsigDemandaId: 0,
                  JuzgadoId: 0,
                  AcreditadoId: id,
                  AsigDfolioDemanda: "",
                  TipoJuicioId: 0,
                  AsigDcomentarios: "",
                  AsigDstatus: 1,
                  DemGestorId: 0,
                  FechaRegistro: new Date(),
                });
                setShowModalEdicion(true);
              }}
            >
              Registrar nueva demanda al acreditado
            </button>
          )}
        </div>
      </div>
      <DataTable
        hover
        data={datatable}
        className="mdbDataTableDemandas"
        searchTop={true}
        searchBottom={false}
        searchLabel="Buscar por cualquier campo"
      />
    </>
  );
};

export default Demandas;
